import { render, staticRenderFns } from "./AcessoDireto.vue?vue&type=template&id=4b40147c&"
import script from "./AcessoDireto.vue?vue&type=script&lang=js&"
export * from "./AcessoDireto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports